window.storefrontToken = null;

window.fetchStorefrontData = async (query, variables = {}) => {
    if (!!window.storefrontToken) {
        const response = await (await fetch('/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': window.storefrontToken,
            },
            body: JSON.stringify({ query, variables }),
        })).json();
        if (response.error) {
            console.log('Error fetching graphql query', response.error);
            return response.error;
        }
        return window.condenseGraphQLResponse(response);
    }
    return false;
};
window.resize = (callbackFunc) => {
    let debouncer = (func, delay) => {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    window.addEventListener('resize', () => {
        debouncer(() => {
            callbackFunc();
        }, 500)();
    });
    callbackFunc();
};
window.condenseGraphQLResponse = (data) => {
    const removeEdgesAndNodes = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(removeEdgesAndNodes);
        } else if (typeof obj === 'object' && obj !== null) {
            if (obj.edges) {
                return obj.edges.map(edge => removeEdgesAndNodes(edge.node));
            }
            const newObj = {};
            for (const key in obj) { // eslint-disable-line guard-for-in
                newObj[key] = removeEdgesAndNodes(obj[key]);
            }
            return newObj;
        }
        return obj;
    };
    return removeEdgesAndNodes(data.data);
};
window.formatTime = (time) => {
    // assuming time is in 24-hour format 'HH:mm'
    const [hour, minute] = time.split(':');
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12; // Convert to 12-hour format
    return `${formattedHour}:${minute} ${period}`;
};
const mobileFooter = () => {
    const targets = document.querySelectorAll('.footer-block__heading');
    targets.forEach(target => {
        target.addEventListener('click', (event) => {
            if (window.innerWidth < 540) {
                event.preventDefault();
                const dropdownEl = target.parentElement;
                const isOpen = dropdownEl.classList.contains('open');
                if (isOpen) {
                    dropdownEl.classList.remove('open');
                }
                else {
                    dropdownEl.classList.add('open');
                }
            }
        });
    });
};
window.addEventListener('DOMContentLoaded', () => {
    mobileFooter();
});